import * as React from 'react';
const SupplierButton: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <span
      className='badge supplier-badge p-2 w-100 position-relative d-flex align-items-center'
      role='button'
    >
      {children}
    </span>
  );
};

export default SupplierButton;
